import type { AuthConfig } from '@upms/auth';
import { env } from '@/config/env';

export const authConfig: AuthConfig = {
  amplify: {
    Auth: {
      Cognito: {
        loginWith: {
          email: true,
        },
        userPoolClientId: env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
        userPoolId: env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
      },
    },
  },
  cookieDomain: env.NEXT_PUBLIC_COOKIE_DOMAIN,
};
